import { fileUrl } from "@/lib/api";

/**
 * Image / Video tag with auth via query parameter (since <img>/<video> can't send headers).
 */
export const SecureMedia = ({ path, contentType, alt, className }) => {
  const isVideo = contentType?.startsWith("video/");
  const url = fileUrl(path);
  if (isVideo) {
    return <video src={url} controls preload="metadata" className={className} />;
  }
  return <img src={url} alt={alt || ""} className={className} />;
};
